export default "__VITE_ASSET__CMRIHB1p__"